import { action } from 'easy-peasy';
import { IActionSetUpdatedBloodPressureReading } from '../types';

const setUpdatedBloodPressureReading: IActionSetUpdatedBloodPressureReading = action(
  (state, payload) => {
    state.statusPatients.patients = state.statusPatients.patients.map(patient => {
      if (patient.latestReadings.bloodPressure?.id === payload.id) {
        patient.latestReadings.bloodPressure = payload;
      }

      return patient;
    });
  },
);

export default setUpdatedBloodPressureReading;
